import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

export default function HomeIndustries() {
  const sliderRef = useRef(null);
  const sectionRef = useRef(null);

  const Settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false, 
    pauseOnHover: true,
    autoplaySpeed: 4000,
    speed: 5000,
    cssEase: "ease",
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,

    customPaging: () => <button className="custom-dot"></button>,

    responsive: [
      { breakpoint: 1050, settings: { slidesToShow: 3 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  useEffect(() => {
    let autoplayTimer = null;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!sliderRef.current) return;

        if (entry.isIntersecting) {
          // 👉 always show first slide
          sliderRef.current.slickPause();
          sliderRef.current.slickGoTo(0, true);

          // 👉 start autoplay after 5 seconds
          autoplayTimer = setTimeout(() => {
            sliderRef.current?.slickPlay();
          }, 4000);
        } else {
          // 👉 stop autoplay if out of view
          sliderRef.current.slickPause();
          if (autoplayTimer) clearTimeout(autoplayTimer);
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      observer.disconnect();
      if (autoplayTimer) clearTimeout(autoplayTimer);
    };
  }, []);


  return (
    <>
      <section className="leverage-area" ref={sectionRef} >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="center-heading">
                <h2 className="heading">industries we serve</h2> </div>
            </div>
            <div className="leverage-container">
              <Slider {...Settings} className="leverage-row" ref={sliderRef}>

                <div className="leverage-col">
                  <div className="leverage-box"  >
                    <img src="/assets/images/home-industries2.webp" loading="lazy" className="img-responsive" alt="leverage" />
                    <div className="leverage-category">
                      <Link className="category-icon" to="/hospitality-laundry-washing-machine-system">
                        <i className="fa-solid fa-arrow-down"></i>
                      </Link>
                    </div>
                    <div className="leveragebox-inner">
                      <div className="heading"> Hospitality</div>
                      <p> Integrated laundry systems delivering high-quality linen care, faster turnaround, and consistent performance.</p>
                    </div>
                  </div>
                </div>


                <div className="leverage-col">
                  <div className="leverage-box">
                    <img src="/assets/images/home-industries1.webp" loading="lazy" className="img-responsive" alt="leverage" />
                    <div className="leverage-category">
                      <Link className="category-icon" to="/heathcare-medical-grade-commercial-laundry">
                        <i className="fa-solid fa-arrow-down"></i>
                      </Link>
                    </div>
                    <div className="leveragebox-inner">
                      <div className="heading">Healthcare</div>
                      <p> End-to-end laundry solutions ensuring hygiene, safety, and consistent output for healthcare environments. </p>
                    </div>
                  </div>
                </div>
                <div className="leverage-col">
                  <div className="leverage-box">
                    <img src="/assets/images/pharma-industries1.webp" loading="lazy" className="img-responsive" alt="leverage" />
                    <div className="leverage-category">
                      <Link className="category-icon" to="/pharmaceutical-grade-commercial-laundry">
                        <i className="fa-solid fa-arrow-down"></i>
                      </Link>
                    </div>
                    <div className="leveragebox-inner">
                      <div className="heading"> Pharma</div>
                      <p> Pharmaceutical systems supporting contamination control, compliance, and consistent production processes.</p>
                    </div>
                  </div>
                </div>


                <div className="leverage-col">
                  <div className="leverage-box">
                    <img src="/assets/images/edu-indutries1.webp" loading="lazy" className="img-responsive" alt="leverage" />
                    <div className="leverage-category">
                      <Link className="category-icon" to="/commercial-washing-machine-for-university">
                        <i className="fa-solid fa-arrow-down"></i>
                      </Link>
                    </div>
                    <div className="leveragebox-inner">
                      <div className="heading"> Education</div>
                      <p> Practical laundry systems that support hygiene, efficiency, and scalable operations across campuses.</p>
                    </div>
                  </div>
                </div>
                <div className="leverage-col">
                  <div className="leverage-box" >
                    <img src="/assets/images/lou-industries.webp" loading="lazy" className="img-responsive" alt="leverage" />
                    <div className="leverage-category">
                      <Link className="category-icon" to="/commercial-laundry-washing-machine">
                        <i className="fa-solid fa-arrow-down"></i>
                      </Link>
                    </div>
                    <div className="leveragebox-inner">
                      <div className="heading"> Commercial Laundries </div>
                      <p>  Integrated laundry solutions designed to optimize workflow, efficiency, and overall output across operations.</p>
                    </div>
                  </div>
                </div>

                <div className="leverage-col">
                  <div className="leverage-box">
                    <img src="/assets/images/home-industries3.webp" loading="lazy" className="img-responsive" alt="leverage" />
                    <div className="leverage-category">
                      <Link className="category-icon" to="/industrial-laundromat-washing-machines">
                        <i className="fa-solid fa-arrow-down"></i>
                      </Link>
                    </div>
                    <div className="leveragebox-inner">
                      <div className="heading"> Laundromats</div>
                      <p> Commercial laundry systems designed for daily operations, quick turnaround times, and dependable performance.  </p>
                    </div>
                  </div>
                </div>

                <div className="leverage-col">
                  <div className="leverage-box">
                    <img src="/assets/images/rail-industries1.webp" loading="lazy" className="img-responsive" alt="leverage" />
                    <div className="leverage-category">
                      <Link className="category-icon"  to="/railway-grade-commercial-laundry-machine">
                        <i className="fa-solid fa-arrow-down"></i>
                      </Link>
                    </div>
                    <div className="leveragebox-inner">
                      <div className="heading"> Railways</div>
                      <p>
                        High-capacity laundry systems designed for continuous operation across large railway networks.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="leverage-col">
                  <div className="leverage-box">
                    <img src="/assets/images/defence-indutriues1.webp" loading="lazy" className="img-responsive" alt="leverage" />
                    <div className="leverage-category">
                      <Link className="category-icon"  to="/defence-grade-commercial-laundry-machine">
                        <i className="fa-solid fa-arrow-down"></i>
                      </Link>
                    </div>
                    <div className="leveragebox-inner">
                      <div className="heading"> Defence</div>
                      <p> Laundry systems aligned with strict hygiene protocols, uniform care, and disciplined operational environments.</p>
                    </div>
                  </div>
                </div>

                <div className="leverage-col">
                  <div className="leverage-box">
                    <img src="/assets/images/home-industries-new4.webp" loading="lazy" className="img-responsive" alt="leverage" />
                    <div className="leverage-category">
                      <Link className="category-icon"  to="/commercial-laundry-for-garment-manufacturing">
                        <i className="fa-solid fa-arrow-down"></i>
                      </Link>
                    </div>
                    <div className="leveragebox-inner">
                      <div className="heading"> Garmets </div>
                    <p>Advanced solutions to protect fabrics, boost efficiency, and deliver consistent, high-quality results.</p>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}





